import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { routerReducer as routing, routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';

import createApiMiddleware from 'middleware/api';
import createApiI18nMiddleware from 'middleware/i18n';
import reducers from 'reducers';

export default function configureStore(history, initialState, req) {
  const middleware = [
    createApiMiddleware(req),
    createApiI18nMiddleware(),
    routerMiddleware(history),
    thunkMiddleware
  ];

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middleware),
    typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : f => f
  )(createStore);

  /** Creating root reduser. */
  const rootReducer = combineReducers(Object.assign(reducers, { routing }));

  return createStoreWithMiddleware(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/configureStore.js